import React from 'react';
import styled from 'styled-components';
import { Dropdown, token } from '@bynder/design-system';
import { IconSettings } from '@bynder/icons';
import { useTranslate } from '@bynder/localization';

import { WFGroupsModal } from '../WorkflowGroupsManagement/WFGroupsModal';
import { AccountMenuItem } from './AccountMenuItem';
import { useAccountMenuItems } from './useAccountMenuItems';

/*
 * bynder-platform/bynder/views/navigation/includes/menu.cfm
 */
export function AccountMenu() {
	const { translate } = useTranslate();
	const menuItems = useAccountMenuItems();

	const liStyles = {
		padding: `0 ${token.spacing5}`,
		height: 50,
		display: 'flex',
		alignItems: 'center',
	};

	if (menuItems.length === 0) {
		return <li className="touch-block" style={liStyles} />;
	}

	return (
		<>
			<Dropdown
				trigger={({ isOpen, ...triggerProps }) => (
					<li
						className={`touch-block ${isOpen ? 'hover' : ''}`}
						style={liStyles}
						{...triggerProps}
					>
						<StyledAnchor href="#" className="admin-dropdown settings">
							<IconSettings />
							{translate('generalSettings')}
						</StyledAnchor>
					</li>
				)}
				minWidth="240px"
			>
				{menuItems.map((item) => (
					<AccountMenuItem item={item} key={item.key} />
				))}
			</Dropdown>
			<WFGroupsModal />
		</>
	);
}

// "font-size: 0" instead of not adding the text ("Settings") because I guess some portals overwrite it with custom theming
const StyledAnchor = styled.a`
	font-size: 0;
`;
